import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-error-show-dialog',
    templateUrl: './error-show-dialog.component.html',
    styleUrl: './error-show-dialog.component.scss',
    standalone: false
})
export class ErrorShowDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ErrorShowDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
